module.exports = BasicBpcComponent;